  <div class="tag-connection custom-theme-modal modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered"
    role="document">
    <div class="modal-content ">
      <div class="modal-header d-block py-3 border-color">
        <div class="row">
          <div class="col-6 pr-0 d-flex align-items-center">
            <h6 class="heading-4">
              <span class=" cursor-pointer" [eventTracker]='{"category":mls.googleEventText.create_posting.category,"action":mls.googleEventText.create_posting.key1,"product_type":"", "product_id":""}'
                 (click)="backToPrevious()">
                <img class="pb-1" src="assets/themes/icons/grey-arrow.svg" alt="back">
              </span>
              <span class="color-grey-700">
              {{mls?.languageText?.create_post_tag?.key1}}<span
                *ngIf="mls?.is_lskey_display==1">(create_post_tag?.key1)</span>
              ({{dss?.tagedUser?.length}}/5)</span>
            </h6>
          </div>
          <div class="col-6 text-right">
            <button (click)="proceedToNextScreen()" type="button"
              class="btn-design filled medium w-25 position-relative h-auto">
             {{mls?.languageText?.create_post_tag?.key2}}
             <span *ngIf="mls?.is_lskey_display==1">(create_post_tag?.key2)</span>
            </button>
          </div>
          <label class="primary-small pl-3 mt-3" *ngIf="err_msg">
            <span class="color-error">
              {{err_msg}}
            </span>
          </label>
        </div>
      </div>
      <div class="d-block py-2 rounded-0 px-4">
        <div class="custom-dropdown position-relative">
          <span class="icon-left mr-2">
            <img src="assets/themes/icons/search-icon.svg" alt="search">
          </span>
          <span class="icon-right" *ngIf="keyword.length > 0" (click)="resetSearchBox()">
            <img src="assets/themes/icons/cancel.svg" width="16" alt="cross">
          </span>
          <input autocomplete="off" id="conSearch" (keyup)="subject.next($event.target.value)" placeholder="{{mls?.languageText?.create_post_tag?.key3}}" />
        </div>
      </div>
      <div class="modal-body py-3 mx-3 tag-connect-list-height">
        <!--Loaders-->
        <div
          *ngIf="connection_data?.list.length==0 && api_in_process==true && showConn=='both'  && dss.posting_data.screen1.tag_to.length == 0"
          class='text-center'>
          <img src="assets/themes/images/img-video-loader.gif" width="40" id="loadmore_post">
        </div>

        <div *ngIf="only_connection_list_data?.list.length==0 && api_in_process==true && showConn!='both'"
          class='text-center'>
          <img src="assets/themes/images/img-video-loader.gif" width="40" id="loadmore_post">
        </div>


        <!--EOf Loaders-->
        <div class="row">
          <div class="col-md-7 pr-0 pl-0">
            <div
              *ngIf="connection_data?.list.length==0 && api_in_process==true && showConn=='both'  && dss.posting_data.screen1.tag_to.length > 0"
              class='text-center'>
              <img src="assets/themes/images/img-video-loader.gif" width="40" id="loadmore_post">
            </div>

            <div class="heading-4 text-center"
              *ngIf="connection_data.header=='' && suggestion_data.header=='' && api_in_process==false && showConn=='both'">
              <img src="assets/themes/icons/no-search-result.svg" alt="">
              <p class="mt-3 color-grey-500">{{mls?.languageText?.create_post_tag?.key5}}</p>
              <span *ngIf="mls?.is_lskey_display==1">(create_post_tag?.key5)</span>
            </div>

            <div class="secondary-paragraph-bold text-center"
              *ngIf="only_connection_list_data.header=='' && suggestion_data.header=='' && api_in_process==false && showConn!='both'">
              {{mls?.languageText?.create_post_tag?.key5}}
              <span *ngIf="mls?.is_lskey_display==1">(create_post_tag?.key5)</span>
            </div>

            <div *ngIf="showConn=='both'" class="position-relative tag-connect-list-height"
            [ngClass]="{'ps':connection_data?.list.length>0}"
              [perfectScrollbar]="config" infiniteScroll [infiniteScrollDistance]="1" [infiniteScrollThrottle]="1000"
              (scrolled)="onScroll()" [scrollWindow]="false">
              <div class="post-modal-tag-list mb-3" *ngIf="connection_data?.list.length>0">
                <h4 class="heading-4 mb-3">{{connection_data?.header}}</h4>
                <!-- connection list start -->

                <label class="row post-modal-tag-list-card mx-0 mb-2 p-2" *ngFor="let conn of connection_data?.list">
                  <div class="col-2 pr-0 pl-0 pt-1">
                    <div class="position-relative card-40">
                      <app-conn-user-for-tag [conn]="conn"></app-conn-user-for-tag>
                    </div>
                  </div>
                  <div class="col-8 px-lg-0">
                    <p class="paragraph-bold">
                      {{conn?.full_name}}
                      <span >
                        <img width="16px" src="assets/themes/icons/connected.svg" alt="connected">
                      </span>
                      <br />
                      <span class="secondary-paragraph" *ngFor="let Connspe of conn?.specialities">
                        <span class="color-grey-500">
                          {{(Connspe?.is_primary==1) ? Connspe?.speciality_name:''}}
                        </span>
                      </span>
                    </p>
                  </div>
                  <div class="col-1 text-right">
                    <label class="checkbox">
                      <input type="checkbox" name=""
                        [eventTracker]='{"category":mls.googleEventText.create_post_tag.category,"action":mls.googleEventText.create_post_tag.key4,"product_type":"", "product_id":""}'
                        [checked]="checkVal(conn)" value="{{conn?.custom_id}}" (click)="addTagTo($event, conn)">
                      <span></span>
                    </label>
                  </div>
                </label>
                <!-- connection list end -->
                <div *ngIf="connection_data?.total_connections>connection_data?.list.length"
                  class="p-2 text-center position-relative button">
                  <span (click)="getOnlyConnection()"
                    class="cursor-pointer">{{connection_data?.view_more_text.replace('|#X#|',connection_data?.total_connections-connection_data?.list.length)}}</span>
                  <span *ngIf="api_in_process==true" class="spinner-border spinner-border-xs spinner-position" role="status" aria-hidden="true">
                  </span>
                  <img class="pl-2" src="assets/themes/icons/rightarrow.svg" width="16" alt="right arrow">
                </div>
              </div>

              <!-- suggestion -->
              <div *ngIf="suggestion_data?.list.length>0" class="post-modal-tag-list">
                <h4 class="heading-4 mb-3">{{suggestion_data?.header}}</h4>
                <!-- list -->

                <div *ngFor="let sugg of suggestion_data?.list">
                  <app-suggestion-tag-card *ngIf="sugg != undefined" [callingFrom]="screenName" [sugg]="sugg" [hasChanged]='hasChanged'
                    [deleteTagObj]='deleteTagObj' (resetErrorMsg)="resetErrorMsg($event)"></app-suggestion-tag-card>
                </div>
              </div>
            </div>
            <div *ngIf="showConn=='connection'" class="ps position-relative"
              [perfectScrollbar]="config" infiniteScroll [infiniteScrollDistance]="1" [infiniteScrollThrottle]="1000"
              (scrolled)="getConnectionList()" [scrollWindow]="false" [ngClass]="{'post-modal-tag-list': only_connection_list_data?.list.length}">
              <div *ngIf="only_connection_list_data?.list.length>0" class="mx-0 mb-2 connection-list-scrollable">
                <h4 class="heading-4 mb-3 cursor-pointer">
                  <img (click)="backTosugg_and_conn()" src="assets/themes/icons/grey-arrow.svg" alt="back">
                  {{only_connection_list_data?.header}}
                </h4>
                <!-- connection list start -->
                <div class="row post-modal-tag-list-card mx-0 mb-2 p-2" *ngFor="let conn of only_connection_list_data?.list">
                  <div class="col-2 pr-0 pl-0 pt-1">
                    <div class="position-relative card-40">
                      <app-conn-user-for-tag [conn]="conn"></app-conn-user-for-tag>
                    </div>
                  </div>
                  <div class="col-8 px-lg-0">
                    <p class="paragraph-bold">
                      {{conn?.full_name}}
                      <span>
                        <img width="16px" src="assets/themes/icons/connected.svg" alt="connected">
                      </span>
                      <br />
                      <span class="secondary-paragraph" *ngFor="let Connspe of conn?.specialities">
                        <span class="color-grey-500">
                          {{(Connspe?.is_primary==1)?Connspe?.speciality_name:''}}
                        </span>
                      </span>
                    </p>
                  </div>
                  <div class="col-2 text-right">
                    <label class="checkbox">
                      <input type="checkbox" name="" [checked]="checkVal(conn)" value="{{conn?.custom_id}}"
                      (click)="addTagTo($event, conn)">
                      <span></span>
                    </label>
                  </div>
                </div>
                <!-- connection list end -->
              </div>
            </div>
          </div>
          <div [perfectScrollbar]="config" *ngIf="dss.tagedUser.length>0"
            class="d-none d-md-block col-md-5 tag-connect-list-height post-modal-tag-list pb-3 pt-2 ps position-relative border-0">

            <h4 class="mb-1 heading-4 mb-3">
              {{mls?.languageText?.create_post_tag?.key6}}
              <span *ngIf="mls?.is_lskey_display==1">(create_post_tag?.key6)</span>
            </h4>
            <div class="row post-modal-tag-list-card mx-0 mb-2 p-2" *ngFor="let tagedList of dss.tagedUser" id="tagedUserDivPost">
              <div class="col-2 px-0 pt-1">
                <div class="position-relative card-40">
                  <app-conn-user-for-tag [conn]="tagedList"></app-conn-user-for-tag>
                </div>
              </div>
              <div class="col-9 pr-0">
                <p class="paragraph-bold">
                  {{tagedList?.full_name}}
                  <br />
                  <span class="secondary-paragraph" *ngFor="let tagedSpe of tagedList?.specialities">
                    <span class="color-grey-500">
                      {{ ( tagedSpe?.is_primary)? tagedSpe?.speciality_name: ''}}
                    </span>
                  </span>
                </p>
              </div>
              <div class="col-1 text-right px-0 pt-2">
                <span class="cursor-pointer">
                  <img [eventTracker]='{"category":mls.googleEventText.create_post_tag.category,"action":mls.googleEventText.create_post_tag.key5,"product_type":"", "product_id":""}'
                   (click)="unTag(tagedList)" src="assets/themes/icons/cancel.svg" alt="cancel">
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="dss.tagedUser.length>0"
        class="d-block d-md-none modal-footer tag-modal-footer bg-color-grey-400 py-2 px-3 border-top">
        <!-- mobile selected -->
        <div *ngFor="let tagedList of dss.tagedUser" class="mr-2 float-left mob-selected-list">
          <div class="position-relative">
            <span class="cursor-pointer mob-unselect-icon">
              <img (click)="unTag(tagedList)"  width="12px" src="assets/themes/icons/gallery-close-icon.svg" alt="cancel">
            </span>
            <app-conn-user-for-tag [conn]="tagedList"></app-conn-user-for-tag>
          </div>
          <div>
            <p class="text-truncate secondary-paragraph-bold">{{tagedList?.registered_name}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>